var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFemale = function SvgFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.502.098a6.326 6.326 0 0 0-6.32 6.317c0 3.086 2.232 5.663 5.153 6.21v1.91H3.679a1.059 1.059 0 0 0 0 2.118h1.656v1.19a1.06 1.06 0 0 0 2.12 0v-1.19h1.74a1.058 1.058 0 1 0 0-2.118h-1.74V12.66a6.32 6.32 0 0 0 5.363-6.245A6.323 6.323 0 0 0 6.502.098Zm0 10.515a4.204 4.204 0 0 1-4.2-4.2c0-2.316 1.883-4.2 4.2-4.2 2.315 0 4.199 1.884 4.199 4.2 0 2.316-1.883 4.2-4.2 4.2Z",
    fill: "#fff"
  })));
};
export default SvgFemale;